module.exports = __webpack_public_path__ + "static/img/18.52c739b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/3/18.png
// module id = s7Fe
// module chunks = 0